import React from 'react';
import { IMedicineTypeTag } from '../interface';

import './styles.scss';

const MedicineTypeTag = ({
    className,
    tagText
}: IMedicineTypeTag) => {

    return (
        <div className={className}>
            <ul className="tags">
                {true &&
                    <li key={"index"} className="medicineTypeTag">
                        <span className="tag-title">{tagText}</span>
                    </li>
                }
            </ul>
        </div>
    );

};

export default MedicineTypeTag;